// extracted by mini-css-extract-plugin
module.exports = {"overlayConfirmation":"jut__ConfirmationModal__overlayConfirmation"};